module.exports = __webpack_public_path__ + "media/styles/images/svg/x-teal-9fc8b8b3ee15813367d12f0ad47d25f7.svg";